import { render, staticRenderFns } from "./StudentPassport.vue?vue&type=template&id=5db5d54f&"
import script from "./StudentPassport.vue?vue&type=script&lang=js&"
export * from "./StudentPassport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports